import { View, ViewDelegate, ButtonView, ButtonViewDelegate, ObjectSelectEvent, ButtonClickEvent } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";

// uses srvg.featuresInstances

export interface ChunkPickerViewDelegate extends ViewDelegate {
    handleObjectSelectEvent( event:ObjectSelectEvent, provider:ChunkPickerView );
}

export class ChunkPickerView extends View implements ButtonViewDelegate{
    /**
     * Button for selecting the next chunk
     */
    nextButton: ButtonView;
    /**
     * Button for selecting the previous chunk
     */
    prevButton: ButtonView;
    /**
     * The selected chunk
     */
    selectedChunk: Chunk;
    /**
     * delegate
     */
    delegate: ChunkPickerViewDelegate;

    constructor( options ) {
        options = options || {};
        options.name = options.name || 'chunkPickerView';
        super( options );
        this.selectedChunk = null;

        this.prevButton = this.addSubView( new ButtonView({ selector: this.selector + ' .backButton' }) );
        this.prevButton.setDelegate( this );
        this.nextButton = this.addSubView( new ButtonView({ selector: this.selector + ' .forwardButton' }) );
        this.nextButton.setDelegate( this );

        this.generatedEvents.push( ObjectSelectEvent );
    }

    /**
     * called when one of the buttons is clicked
     * changes the selected index if the button represents a valid index
     */
    handleButtonClickEvent( event:ButtonClickEvent, button ) {
        if( button != this.prevButton && button != this.nextButton ) { return; }

        var offset = 0;
        if( button == this.prevButton ) { offset = -1; }
        if( button == this.nextButton ) { offset = 1; }

        var selectedIndex = app.timeline.chunkRangeModel.findChunkIndex( this.selectedChunk );

        if( selectedIndex + offset >= 0 && selectedIndex + offset < app.timeline.chunkRangeModel.length ) {
            var newChunk = app.timeline.chunkRangeModel.getChunk( selectedIndex+offset );
            this.pickChunk( newChunk );
        }
        else {
            srvg.debug.console( 'Invalid chunk range index', selectedIndex+offset );
        }
    }

    pickChunk( chunk: Chunk ) {
        this.setChunk( chunk );
        //console.log( 'chunk picked:', chunk.getName(), chunk.getDescription() );
        this.triggerEvent(new ObjectSelectEvent( this, this.selectedChunk ));
    }

    setChunk( chunk: Chunk ) {
        //console.log("ChunkPickerView: setChunk()");
        this.selectedChunk = chunk;
        this.refresh();
    }

    refresh() {
        if( this.selectedChunk ) {
            // disable prevButton if getDisablePastMatchdays is true
            // as soon as the previous chunk of the selected chunk switches to betstop
            // else: we have to ensure that the prevButton is always enabled except of Match Day 1 Group A & B
            if (srvg.featuresInstances.getDisablePastMatchdays()
                && (this.selectedChunk.getPreviousBetstop() <= app.server.getTime())) {
                this.prevButton.disable();
            } else if ((app.timeline.currentChunkModel.chunk.competitionStageTypeId == 1)
                && (this.selectedChunk.competitionStageTypeId == 1)
                && (this.selectedChunk.nr == 1)) {
                this.prevButton.disable();
            } else {
                this.prevButton.enable();
                //console.log("            previousChunk not existing -> disabling prev button");
            }

            if (this.selectedChunk.next) {
                this.nextButton.enable();
            } else {
                this.nextButton.disable();
                //console.log("            nextChunk not existing     -> disabling next button");
            }
            if(!this.selectedChunk.prev && !this.selectedChunk.next) {
                //console.log("------>>>>>>>>>>>>>>>>>>>>>>>>>>>   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");

                // for some odd reason previous AND next chunks are not available on betstop from time to time
                // due to that next/prev buttons are disabled
                // as it is unclear how to fix this in a generic way I activate them by hand

                // group phase
                if(this.selectedChunk.competitionStageType == "league") {
                    // first matchday, first games
                    if(this.selectedChunk.nr == 1 && this.selectedChunk.matches[0].matchset.nr == 1) {
                        this.nextButton.enable();
                    }
                    // third matchday, last games
                    else if (this.selectedChunk.nr == 9 && this.selectedChunk.matches[0].matchset.nr == 3) {
                        this.prevButton.enable()
                    }
                    // third matchday, last games
                    else if (this.selectedChunk.nr == 12 && this.selectedChunk.matches[0].matchset.nr == 3) {
                        this.nextButton.disable()
                    }
                    // all other combinations
                    else {
                        this.nextButton.enable();
                        this.prevButton.enable()
                    }
                }
                // final stage
                else {
                    // the special cases are only necessary if getDisablePastMatchdays is not true
                    if(!srvg.featuresInstances.getDisablePastMatchdays()) {
                        // second round sixteen
                        if ((this.selectedChunk.nr == 2 && this.selectedChunk.matches[0].matchset.nr == 4) ||
                            // quarterfinal
                            (this.selectedChunk.nr == 3 && this.selectedChunk.matches[0].matchset.nr == 3) ||
                            // first semifinal
                            (this.selectedChunk.nr == 4 && this.selectedChunk.matches[0].matchset.nr == 2) ||
                            // second semifinal
                            (this.selectedChunk.nr == 5 && this.selectedChunk.matches[0].matchset.nr == 2) ||
                            // final
                            (this.selectedChunk.nr == 6 && this.selectedChunk.matches[0].matchset.nr == 1)) {
                            this.prevButton.enable()
                            // second round sixteen
                        } else if ((this.selectedChunk.nr == 2 && this.selectedChunk.matches[0].matchset.nr == 4) ||
                            // quarterfinal
                            (this.selectedChunk.nr == 3 && this.selectedChunk.matches[0].matchset.nr == 3) ||
                            // first semifinal
                            (this.selectedChunk.nr == 4 && this.selectedChunk.matches[0].matchset.nr == 2) ||
                            // second semifinal
                            (this.selectedChunk.nr == 5 && this.selectedChunk.matches[0].matchset.nr == 2)) {
                            this.nextButton.disable();
                        }
                        // all other combinations
                        else {
                            this.nextButton.enable();
                            this.prevButton.enable()
                        }
                    }
                }
            }
        }
        if (this.$domNode.css('display') === 'none') {
            this.fadeIn();
        }
        super.refresh();
    }

    fadeIn() {
        $(
            this.prevButton + ', ' +
            this.nextButton
        ).fadeIn(500);
    }

    disable() {
        // hide all elements that would still be shown after other elements are already enabled
        this.prevButton.disable();
        this.prevButton.hide(false);
        this.nextButton.disable();
        this.nextButton.hide(false);

        this.$domNode.animate( { opacity: 0 }, 300 );
        super.disable();
    }
}